// extracted by mini-css-extract-plugin
module.exports = {"stickToEnd":"AcademyMobileHeader_stickToEnd__etXmr","textContainer":"AcademyMobileHeader_textContainer__Vzc6i","title":"AcademyMobileHeader_title__B3rTJ"};